import { styled } from 'styled-components';

export const Root = styled.div < { background?: string | null } >`
  width: 100%;
  padding: ${(p) => p.theme.spacing.get(5, 8)};
  border-radius: 3px;
  background: ${(p) => p.background || '#AD06E7'};
  align-self: stretch;

  ${(p) => p.theme.breakpoints.up('md')} {
    padding: ${(p) => p.theme.spacing.get(3, 8)};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: ${(p) => p.theme.spacing.get(4)};
  }
`;

export const Content = styled.div`
  max-width: 750px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${(p) => p.theme.spacing.get(3)};
  color: #fff;

  ${(p) => p.theme.breakpoints.up('md')} {
    padding: ${(p) => p.theme.spacing.get(6, 0)};
  }
`;

export const ItemImage = styled.img`
  // Important for fix slick styles
  display: none !important;

  ${(p) => p.theme.breakpoints.up('md')} {
    display: block !important;
    flex-shrink: 0;
    width: 300px;
    height: 300px;
    object-fit: contain;
    object-position: center;
  }
`;

export const Name = styled.div`
  ${(p) => p.theme.typography.base};
  font-size: 26px;
  letter-spacing: -0.39px;
  text-transform: uppercase;

  ${(p) => p.theme.breakpoints.up('md')} {
    font-size: 48px;
    letter-spacing: -0.72px;
  }
`;

export const Description = styled.div`
  font-family: ${(p) => p.theme.typography.fontFamilySecondary};
  font-size: 12px;

  ${(p) => p.theme.breakpoints.up('md')} {
    font-size: 16px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: ${(p) => p.theme.spacing.get(4)};
  gap: ${(p) => p.theme.spacing.get(4)};

  ${(p) => p.theme.breakpoints.up('md')} {
    padding-top: ${(p) => p.theme.spacing.get(6)};
    gap: ${(p) => p.theme.spacing.get(6)};
  }

  ${(p) => p.theme.breakpoints.down('mobile')} {
    gap: ${(p) => p.theme.spacing.get(1)};
  }
`;
